import React, { useMemo } from "react";
import { Grid, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Question from "../../components/Question";
import ContinueButton from "../../components/ContinueButton";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

import { reset as stripeReset } from "../../redux/stripeSlice";
import { setPayMethod as updatePayMethod, setPaid as updatePaid } from "../../redux/userSlice";

export default function InsuranceOptions(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const backPath = props.backPath ?? "/recent-photo";
    const routes = {
        onFile: "/anything-else-toknow",
        changed: "/insurance/provider",
        cash: "/payment",
        ...(props.routes || {}),
    };

    const options = useMemo(
        () => [
            { key: "onFile", title: "Use my insurance on file", to: routes.onFile },
            { key: "changed", title: "My insurance has changed", to: routes.changed },
            { key: "cash", title: "I will pay out of pocket", to: routes.cash },
        ],
        [routes.onFile, routes.changed, routes.cash]
    );

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, backPath, navigate);
    };

    const handleClick = (opt) => {
        props.onSelect?.(opt.key);

        if (opt.key === "cash") {
            if (user.payMethod === "insurance") {
                dispatch(stripeReset());
                dispatch(updatePaid(false));
            }
            dispatch(updatePayMethod("self"));
        } else if (opt.key === "onFile" || opt.key === "changed") {
            dispatch(updatePayMethod("insurance"));
        }

        const state = {
            returning: true,
            insuranceChanged: opt.key === "changed",
            onFile: opt.key === "onFile",
            payOutOfPocket: opt.key === "cash",
        };

        setPageAndDeferNavigate(dispatch, opt.to, () =>
            navigate(opt.to, { state })
        );
    };

    return (
        <Question
            onBack={handleBack}
            title="How would you like to proceed?"
            input={
                <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            width: { xs: "100%", sm: "80%", md: "70%" },
                            maxWidth: 600,
                            justifyContent: "center",
                        }}
                    >
                        {options.map((opt) => (
                            <Grid
                                item
                                xs={12}
                                key={opt.key}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <ContinueButton
                                    sx={{ width: "100%", maxWidth: "500px" }}
                                    onClick={() => handleClick(opt)}
                                    title={opt.title}
                                    selected={true}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            }
        />
    );
}
